import { axiosPost } from '../AxiosRequests';
import { AdminLogin } from '../ApiEndPoints';

export default class AuthenticationServices {
    
    async adminLogin(request) {
        return axiosPost(AdminLogin, request);
    }
}